import { render, staticRenderFns } from "./AccountService.vue?vue&type=template&id=732de0bd"
import script from "./AccountService.vue?vue&type=script&lang=js"
export * from "./AccountService.vue?vue&type=script&lang=js"
import style0 from "./AccountService.vue?vue&type=style&index=0&id=732de0bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports